export default __webpack_public_path__ + "static/oil_storing-a79dfa40c5739042a46ad41bb952500d.webp";